import { render, staticRenderFns } from "./Relatie.vue?vue&type=template&id=3664d5ba&"
import script from "./Relatie.vue?vue&type=script&lang=ts&"
export * from "./Relatie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports